// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"a77369f2","522":"4a40a903","545":"32783348","551":"a22a53b6","605":"dd6279ae","662":"c0af0fd1"}[chunkId] + ".chunk.js";
};